import { tv, type VariantProps } from 'tailwind-variants'

const textButton = tv({
  base: [
    'inline-flex items-center justify-center rounded-sm font-semibold text-primary',
    'transition-colors select-none',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2',
    'disabled:pointer-events-none disabled:text-gray-600',
  ],
  variants: {
    size: {
      sm: 'h-8 px-2 text-sm',
      base: 'h-10 px-2 text-base',
    },
  },
  defaultVariants: {
    size: 'sm',
  },
})

type TextButtonVariants = VariantProps<typeof textButton>

export type TextButtonProps = TextButtonVariants &
  Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'className'> & {
    className?: string
  }

export function TextButton({
  size,
  className,
  type = 'button',
  ...rest
}: TextButtonProps) {
  return (
    <button
      type={type}
      className={textButton({ size, className })}
      {...rest}
    />
  )
}
